import AuthLayout from "@/features/auth/auth-layout";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";
import { Trans } from "react-i18next";
import useGetMySelf from "@/features/auth/use-get-my-self";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { getDefaultPageByIdentity } from "@/pages";
import { getIdentity } from "@/features/ui/helpers/identity-helpers";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import AppButton from "@/features/line-sheet-sets/app-button";
import { getCanonicalUrl } from "@/shared/utils/canonical-url";

export default function SignUpPendingPage() {
  const navigate = useNavigate();
  const { isLoading, data: user, error } = useGetMySelf();
  const { t, tTitle } = useI18nHelper();

  useEffect(() => {
    if (user && user.companies.length > 0) {
      navigate(getDefaultPageByIdentity(getIdentity()));
    }
  }, [user, navigate]);

  if (isLoading) {
    return <>loading...</>;
  }

  if (error) {
    return <>error</>;
  }

  return (
    <AuthLayout title={tTitle("auth:welcome")} tail={null}>
      <Helmet>
        <title>Pathrade | Sign Up</title>
        <meta
          name="description"
          content="Sign up for the Pathrade to use a B2B Fashion Platform tailored for the global luxury fashion landscape with a seamless ordering experience and insightful analytics."
        />
        <link
          rel="canonical"
          href={getCanonicalUrl()}
        />
        <meta
          property="og:title"
          content="Pathrade | Sign up to the Luxury Fashion B2B Platform & Saas."
        />
        <meta
          property="og:description"
          content="Sign up for the Pathrade to use a B2B Fashion Platform tailored for the global luxury fashion landscape with a seamless ordering experience and insightful analytics."
        />
        <meta
          property="og:url"
          content={getCanonicalUrl()}
        />
      </Helmet>
      <Flex flexDirection={"column"} gap={"24px"}>
        <Box textAlign="center">
          {t("auth:pending_message", {
            mobileNumber: user?.mobileNumber || "",
            email: "support@unotrading.co.kr",
          })
            .split("\n")
            .map((line, index) => (
              <Text key={index}>
                {line}
                <br />
              </Text>
            ))}
        </Box>
        {/* 승인을 기다리는 동안 패스픽을 소개하는 카드 */}
        <Flex
          flexDirection={"column"}
          gap={"12px"}
          backgroundColor={"#EFF4FF"}
          border={"1px solid #D6E4FF"}
          borderRadius={"8px"}
          padding={"16px"}
        >
          <Text fontSize={"14px"} fontWeight={"700"} color={"#22221F"}>
            <Trans
              i18nKey={"auth:sign_up_pending.path_pick.title"}
              components={{
                br: <br />,
              }}
            />
          </Text>
          <Text fontSize={"12px"} color={"#6F6F6C"}>
            {t("auth:sign_up_pending.path_pick.description")}
          </Text>
          <Text fontSize={"12px"} color={"#6F6F6C"}>
            <Trans
              i18nKey={"auth:sign_up_pending.path_pick.trial"}
              components={{
                highlight: (
                  <Text as="span" color={"#1272EF"} fontWeight={"700"} />
                ),
              }}
            />
          </Text>
          <AppButton
            variant={"primary"}
            size={"large"}
            width={"100%"}
            chakraProps={{ height: "40px" }}
            onClick={() => {
              navigate("/");
            }}
          >
            <Text fontSize={"14px"} fontWeight={"700"}>
              {tTitle("auth:sign_up_pending.button.view_path_pick.do")}
            </Text>
          </AppButton>
        </Flex>
      </Flex>
    </AuthLayout>
  );
}
